
export const PRODUCT_COVER = "cover_large"
export const PRODUCT_COVER_OLD = "cover-old_large"
export const PRODUCT_PHOTOGRAMME = "photogramme_large"
export const PRODUCT_BOBINEZ = "bobinez_large"
export const PRODUCT_ARCHIVE = "bonus-archive_large"
export const BONUS_EXCLU = "bonus-exclu_large"

export const DIRECTOR_AVATAR = "avatar_large"
export const DIRECTOR_AVATAR_MEDIUM = "avatar_medium"
export const DIRECTOR_AVATAR_SMALL = "avatar_small"
export const DIRECTOR_TOP = "top_large"
export const DIRECTOR_TOP_ALT = "top-alt_large"

export const MOBILE_HEADER_LARGE = "mobile-en-tete_large"
export const SVOD_LARGE = "image-large-abonnement_large"

export const CATEGORY_BANNER_BIG = "banner_big"
export const CATEGORY_BANNER_LARGE = "banner_large"
export const CATEGORY_BANNER_MEDIUM = "banner_medium"
export const CATEGORY_BANNER_SMALL = "banner_small"
export const CATEGORY_LOGO_LARGE = "logo_large"
export const CATEGORY_LOGO_MEDIUM = "logo_medium"
export const CATEGORY_LOGO_SMALL = "logo_small"
export const CATEGORY_TREASURE = "treasure_large"
export const CATEGORY_SELECTION = "selection_large"
export const CATEGORY_SELECTION_PREVIOUS = "moisprecedents_large"
export const CATEGORY_BONUS = "bonus_large"
export const CATEGORY_TEASER = "teaser_large"
export const CATEGORY_FREEBOX_LARGE = "freebox_large"
export const CATEGORY_FREEBOX_EVENEMENT = "freebox-evenement_large"

export const CATEGORY_PREHOME_PORTRAIT_MOBILE = "prehome-portrait-mobile_large"
export const CATEGORY_PREHOME_PORTRAIT_TABLET = "prehome-portrait-tablet_large"
export const CATEGORY_PREHOME_LANDSCAPE_DESKTOP = "prehome-landscape-desktop_large"
export const CATEGORY_PREHOME_LANDSCAPE_MOBILE = "prehome-landscape-mobile_large"
export const CATEGORY_PREHOME_LANDSCAPE_TABLET = "prehome-landscape-tablet_large"

const defaults = [
	{
		source: "/static/images/default_corpus.jpg",
		targets: "*"
	},
	{
		source: "/static/images/placeholder_viewed.png",
		targets: [PRODUCT_PHOTOGRAMME, CATEGORY_TREASURE]
	},
	{
		source: "/static/images/default_director.png",
		targets: [DIRECTOR_TOP, DIRECTOR_AVATAR, DIRECTOR_AVATAR_MEDIUM, DIRECTOR_AVATAR_SMALL, DIRECTOR_TOP_ALT]
	}
]

export default function image(object, type, fallback_type) {
	let image = null
	if (object.images) {
		if (type) {
			image = object.images.find(i => i.type == type)
		}
		if (!image && fallback_type) {
			image = object.images.find(i => i.type == fallback_type)
		}
		//if (!image) {
		//image = object.images[0]
		//}
		if (image) {
			image = image.source
		}
	}

	if (!image) {
		image = defaults.find(d => d.targets.includes(type))
		if (!image) {
			image = defaults.find(d => d.targets == "*")
		}
		image = image.source
	}

	return image
}

export function imagesOfType(object, type) {
	if (!object.images) {
		return null
	}

	return object.images.filter(image => image.type === type).map(image => image.source)
}
